import styled from 'styled-components';
import { Card } from 'antd';

export const UI_Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8fafc;
`;

export const UI_Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
`;

export const UI_HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UI_HeaderRight = styled.div``;

export const UI_Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
`;

export const UI_Subtitle = styled.p`
  margin: 0;
  font-size: 12px;
  color: #64748b;
`;

export const UI_Filters = styled.div`
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e2e8f0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UI_FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const UI_FilterLabel = styled.span`
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  min-width: 60px;
`;

export const UI_DashboardContent = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
`;

export const UI_CardTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

export const UI_CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
  min-height: 24px;
`;

export const UI_WidgetHoverControls = styled.div<{ $isDragging?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  opacity: ${(props) => (props.$isDragging ? 1 : 0)};
  transform: ${(props) => (props.$isDragging ? 'translateY(0)' : 'translateY(-1px)')};
  transition: opacity 0.16s ease, transform 0.16s ease;
`;

export const UI_WidgetSortableItem = styled.div<{ $isDragging?: boolean }>`
  flex: 1;
  min-width: 300px;
  display: flex;

  &:hover .widget-hover-controls,
  &:focus-within .widget-hover-controls {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const UI_WidgetCard = styled(Card)<{ $isDragging?: boolean }>`
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-color: ${(props) => (props.$isDragging ? '#3b82f6' : '#e2e8f0')};
  box-shadow: ${(props) =>
    props.$isDragging
      ? '0 12px 28px -6px rgba(37, 99, 235, 0.22)'
      : 'none'};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${(props) => (props.$isDragging ? '#3b82f6' : '#cbd5e1')};
    box-shadow: ${(props) =>
      props.$isDragging
        ? '0 12px 28px -6px rgba(37, 99, 235, 0.22)'
        : '0 4px 12px rgba(15, 23, 42, 0.05)'};
  }

  .ant-card-body {
    padding: 16px;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const UI_WidgetDragHandle = styled.button<{ $isDragging?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 22px;
  padding: 0 7px;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  cursor: ${(props) => (props.$isDragging ? 'grabbing' : 'grab')};
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  transition: all 0.15s ease;

  &:hover {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const UI_WidgetCloseBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #fef2f2;
    border-color: #fecaca;
    color: #dc2626;
  }
`;

export const UI_EmptyWidgetsState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 260px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 24px;
`;

export const UI_EmptyWidgetsText = styled.span`
  font-size: 13px;
  color: #64748b;
`;

export const UI_KPICard = styled(Card)`
  height: 400px;
  flex: 1;
  min-width: 300px;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
    height: calc(100% - 48px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const UI_KPIGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  flex: 1;
  min-height: 0;
  justify-content: center;
  align-items: flex-start;
`;

export const UI_KPIItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  width: 150px;
  flex: 0 0 auto;
`;

export const UI_KPIValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 4px;
`;

export const UI_KPILabel = styled.div`
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
`;

export const UI_Sparkline = styled.div`
  font-size: 12px;
`;

export const UI_ProgressCard = styled(Card)`
  height: 400px;
  flex: 1;
  min-width: 300px;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
    height: calc(100% - 48px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const UI_ProgressList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const UI_ProgressItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const UI_ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UI_ProgressName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #374151;
`;

export const UI_ProgressStats = styled.span`
  font-size: 11px;
  color: #64748b;
`;

export const UI_ProgressBar = styled.div`
  height: 6px;
  background: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
`;

export const UI_ProgressFill = styled.div<{ percentage: number; color: string }>`
  height: 100%;
  width: ${(props) => props.percentage}%;
  background: ${(props) => props.color};
  border-radius: 3px;
  transition: width 0.3s ease;
`;

export const UI_StaffCard = styled(Card)`
  height: 400px;
  flex: 1;
  min-width: 300px;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
    height: calc(100% - 48px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const UI_StaffTable = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  font-size: 11px;
`;

export const UI_StaffHeader = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 120px;
  gap: 8px;
  padding: 6px 0;
  font-weight: 600;
  color: #64748b;
  border-bottom: 1px solid #e5e7eb;
`;

export const UI_StaffRow = styled.div<{ hasError?: boolean }>`
  display: grid;
  grid-template-columns: 40px 1fr 120px;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #f3f4f6;
  color: ${(props) => (props.hasError ? '#ef4444' : '#374151')};
  background: ${(props) => (props.hasError ? 'rgba(239, 68, 68, 0.05)' : 'transparent')};
  border-radius: 4px;
  margin: 2px 0;
`;

export const UI_StaffRecordsHeader = styled.span`
  text-align: right;
`;

export const UI_StaffRecordsValue = styled.span`
  text-align: right;
  font-family: 'JetBrains Mono', 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
`;

export const UI_HeatmapCard = styled(Card)`
  height: 480px;
  flex: 2;
  min-width: 280px;
  max-width: 100%;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
    height: calc(100% - 48px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const UI_Heatmap = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  overflow-y: auto;
  max-width: 100%;
`;

export const UI_HeatmapTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 11px;

  th,
  td {
    padding: 4px 8px;
    text-align: center;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  th {
    background: #f8fafc;
    font-weight: 600;
    color: #64748b;
  }

  td:first-child,
  th:first-child {
    text-align: left;
    font-weight: 500;
    background: #f8fafc;
    color: #374151;
    width: 40%;
  }

  td:not(:first-child),
  th:not(:first-child) {
    width: 30%;
  }

  @media (max-width: 768px) {
    font-size: 10px;

    th,
    td {
      padding: 2px 4px;
    }

    td:first-child,
    th:first-child {
      width: 50%;
    }

    td:not(:first-child),
    th:not(:first-child) {
      width: 25%;
    }
  }
`;

export const UI_HeatmapCell = styled.div<{ intensity: number }>`
  background: ${(props) => {
    if (props.intensity === -1) {
      return 'rgba(148, 163, 184, 0.2)';
    }
    const opacity = Math.min(props.intensity / 20, 1);
    return `rgba(239, 68, 68, ${opacity})`;
  }};
  color: ${(props) => (props.intensity === -1 ? '#64748b' : props.intensity > 10 ? 'white' : '#374151')};
  padding: 2px 4px;
  border-radius: 2px;
  font-weight: 500;
`;

export const UI_ErrorsCard = styled(Card)`
  height: 480px;
  flex: 1;
  min-width: 300px;
  overflow: hidden;
  .ant-card-body {
    padding: 16px;
    height: calc(100% - 48px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const UI_ErrorsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const UI_ErrorItem = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  max-width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
    padding: 6px;
  }
`;

export const UI_ErrorTime = styled.div`
  font-size: 10px;
  color: #b91c1c;
  font-weight: 500;
  min-width: 50px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: auto;
    font-size: 9px;
  }
`;

export const UI_ErrorDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
`;

export const UI_ErrorUser = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const UI_ErrorForm = styled.div`
  font-size: 10px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 9px;
  }
`;

export const UI_ErrorNote = styled.div`
  font-size: 10px;
  color: #dc2626;
  font-style: italic;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 9px;
  }
`;

export const UI_TopCardsContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const UI_BottomCardsContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const UI_MobileFilterButton = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;
